import {
  isEmpty,
  isNull,
  keyBy,
  mapValues,
} from 'lodash';

export const A2C_WEBLABS = {
  AUTHOR_BOOKS_PAGE_321676: 'AUTHOR_BOOKS_PAGE_321676',
  A2C_BR_MEDIA_UPLOAD_324175: 'A2C_BR_MEDIA_UPLOAD_324175',
  VANITY_URL_336122: 'VANITY_URL_336122',
  A2C_BR_NEW_SALES_RANK_327992: 'A2C_BR_NEW_SALES_RANK_327992',
  A2C_ROW_NEW_SALES_RANK_327993: 'A2C_ROW_NEW_SALES_RANK_327993',
};

export const getAccount = ({
  account,
}) => account;
// This is how the AuthorStore reads the 'author' data from the bootstrap data
// TODO: We probably shouldn't be conditionally changing the data struct type based on
// the number returned, so the backend should be fixed and this check should be removed
export const getAuthors = ({
  author: authorData = null,
}) => {
  if (isNull(authorData)) return {};
  if (!Array.isArray(authorData)) {
    return ({
      [authorData.amazonAuthorId]: authorData,
    });
  }
  return authorData.reduce((accumulator, currentValue) => ({
    ...accumulator,
    [currentValue.amazonAuthorId]: currentValue,
  }), {});
};
export const getIdentities = ({ identities }) => identities || [];
export const getTldMarketplace = data => data.tld_marketplace;

// for some authors currentAuthorId in preferences is null or amazonAuthorId doesn't exist in identities
// fallback to first author in identities as we did in other places,
// see https://tiny.amazon.com/m9zo7bkc/codeamazpackAmazblob20e0app
// TODO: AUTHOR-10620 - Ensure currentAuthorId from bootstrap data is not null
export const getActiveIdentity = ({
  identities = [],
  preferences: {
    currentAuthorId,
  },
}) => (
  identities.find(({
    amazonAuthorId,
  }) => amazonAuthorId === currentAuthorId) || identities[0] || {}
);
export const getActiveAuthorId = bootstrapData => getActiveIdentity(bootstrapData).amazonAuthorId || null;
export const getActiveMarketplaceId = bootstrapData => getTldMarketplace(bootstrapData)
 || getActiveIdentity(bootstrapData).marketplace || 'ATVPDKIKX0DER';
export const getI18n = (data) => {
  if (isEmpty(data.i18n)) return null;
  const {
    locale,
  } = data.i18n[0];
  const localeStrings = data.i18n
    .filter(({
      locale: assetLocale,
    }) => assetLocale === locale)
    .map(({
      data: {
        strings,
      },
    }) => strings)
    .reduce((accumulator, currentValue) => ({
      ...accumulator,
      ...currentValue,
    }), {});
  return {
    locale,
    strings: localeStrings,
  };
};
export const getWeblabs = ({
  weblabs,
}) => {
  if (!weblabs) return {};
  const a2cWeblabIds = Object.keys(A2C_WEBLABS);
  const a2cWeblabs = weblabs.filter(weblab => a2cWeblabIds.includes(weblab.experiment));
  return mapValues(
    keyBy(a2cWeblabs, ({
      experiment,
    }) => A2C_WEBLABS[experiment]),
    ({
      treatment = 'C',
    }) => (treatment === 'T1'),
  );
};

export const getTerms = ({ a2c_config }) => {
  if (!a2c_config) return {};
  const {
    privacyPolicyUrl,
    conditionsOfUseUrl,
    cookiePolicyUrl,
    termsAndConditionsKey,
  } = a2c_config;
  return {
    privacyPolicyUrl,
    conditionsOfUseUrl,
    cookiePolicyUrl,
    termsAndConditionsKey,
  };
};
